import { CategoryWrapper } from "./styles";
import { GenerateSlug } from "../../../utils/slug";
import { Image, Box } from "../../../styles/basicStyles";
import { useRouter } from "next/router";
import { colors } from "../../../styles/colors";
import { FC } from "react";
import Typography from "../../../components/typography";

interface BannerProps {
  title: string;
  date: string;
  category: string;
  image?: string;
  description: string;
}

const Banner: FC<BannerProps> = ({
  title,
  date,
  category,
  image,
  description
}) => {
  const router = useRouter();

  return (
    <Box fDirection="column" mb={1.563}>
      <Typography
        as='h1'
        fSize={{ md: 2.75, xxs: 2.25 }}
        lHeight={{ md: 3.5, xxs: 3 }}
        fWeight={700}
        color={colors.black}
        mb={1.625}
        mt={1.875}
      >
        {title}
      </Typography>
      <Box fAlign="center">
        <CategoryWrapper onClick={() =>router.push(`/blog?category=${GenerateSlug(category)}`)}>
          <Typography
            fSize={{ md: 1, xxs: 1.188 }}
            lHeight={{ md: 0.938, xxs: 1.125 }}
            fWeight={600}
            color={colors.black}
          >
            {category}
          </Typography>
        </CategoryWrapper>
        <Typography
          fSize={{ md: 1, xxs: 0.938 }}
          lHeight={{ md: 1.188, xxs: 1.125 }}
          fWeight={400}
          color='#595858'
          ml={0.625}
        >
          {date}
        </Typography>
      </Box>
      <Image mt={2.25} w={{ md: 50, xxs: "100%" }} src={image} alt='main image' />
      <Typography
        fSize={{ md: 1.313, xxs: 1 }}
        lHeight={{ md: 2, xxs: 1.5 }}
        fWeight={400}
        color={colors.black}
        mt={2.938}
        dangerouslySetInnerHTML={{ __html: description?.replace(/<p><\/p>/g, '<p>&nbsp;</p>') }}
      />
    </Box>
  );
};

export default Banner;
